import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Avatar, Box, Typography, Button } from "@mui/material"
import LogoutIcon from "@mui/icons-material/Logout"

import { diagnosticToBoolean } from "config/helpers"

import useAppStore from "store/app"
import useAlertStore from "store/alert"

import Layout from "./Layout"
import Navigation from "./Navigation"

import FirstName from "components/shared/fields/FirstName"
import LastName from "components/shared/fields/LastName"
import BirthDate from "components/shared/fields/BirthDate"
import PhoneNumber from "components/shared/fields/PhoneNumber"
import Gender from "components/shared/fields/Gender"
import Height from "components/shared/fields/Height"
import Weight from "components/shared/fields/Weight"
import SufferedAnInjury from "components/shared/fields/check/SufferedAnInjury"
import HighCholesterol from "components/shared/fields/check/HighCholesterol"
import Hypertension from "components/shared/fields/check/Hypertension"
import Diabets from "components/shared/fields/check/Diabets"

import BaseLink from "components/base/Link"
import SecondaryButton from "components/shared/buttons/SecondaryButton"
import LanguageSelect from "components/containers/LanguageSelect"
import useTranslation from "../../../hooks/use_translation"
import RtlIconWrapper from "../../shared/RtlIconWrapper"

const Personal_data = () => {
  const { first_name, last_name, email } = useAppStore((state) => state.user)
  const fields = useAppStore((state) => state.fields)
  const updateFieldErrorMessage = useAppStore((state) => state.updateFieldErrorMessage)
  const logout = useAppStore((state) => state.logout)
  const getClientProfile = useAppStore((state) => state.getClientProfile)
  const updateClientInfo = useAppStore((state) => state.updateClientInfo)
  const syncClient = useAppStore((state) => state.syncClient)
  const syncFields = useAppStore((state) => state.syncFields)
  const showAlert = useAlertStore((state) => state.showAlert)

  // const mode = useAppStore((state) => state.meta.mode)
  // const setMode = useAppStore((state) => state.setMode)

  const navigate = useNavigate()

  const { pages, messages } = useTranslation()

  useEffect(() => {
    getClientProfile().then((response) => {
      syncClient(response.data)
      syncFields(response.data)
    })
  }, [])

  const handleSubmit = (event) => {
    event.preventDefault()

    let valid = true

    const errorsCheck = [
      "first_name",
      "last_name",
      "birthday",
      "phone_number",
      "gender",
      "weight",
      "height",
      "cholesterol",
      "hypertension",
      "injury",
      "diabetes",
    ]

    errorsCheck.map((field) => {
      if (fields[field].error_message !== "") {
        valid = false
      }

      if (!fields[field]?.touched) {
        valid = false
        updateFieldErrorMessage(field, "This field is required")
      }
    })

    if (!valid) return

    const params = {
      first_name: fields.first_name?.input_value,
      last_name: fields.last_name?.input_value,
      phone_number: fields.country_code?.input_value + " " + fields.phone_number?.input_value,
      birthday: fields.birthday?.input_value,
      email: fields.email?.input_value,
      gender: fields.gender?.input_value,
      weight: fields.weight?.input_value,
      height: fields.height?.input_value,
      cholesterol: diagnosticToBoolean(fields.cholesterol?.input_value),
      hypertension: diagnosticToBoolean(fields.hypertension?.input_value),
      injury: diagnosticToBoolean(fields.injury?.input_value),
      diabetes: diagnosticToBoolean(fields.diabetes?.input_value),
    }

    updateClientInfo(params)
      .then((response) => {
        syncClient(response.data)
        showAlert(messages?.success_update_user_info, "success")
      })
      .catch((error) => showAlert(error.message, "error"))
  }

  const handleLogout = () => {
    logout()
      .then(() => {
        navigate("/")
      })
      .catch((error) => {
        showAlert(error.message, "error")
      })
  }

  return (
    <Layout>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", mb: 4, alignItems: "center" }}>
          <Avatar sx={{ height: 60, width: 60 }} />
          <Box sx={{ ml: 1.5 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, ml: 0.5 }}>
              {pages?.personal_data?.hello} , {first_name} {last_name}!
            </Typography>
            <Button
              endIcon={
                <RtlIconWrapper>
                  <LogoutIcon />
                </RtlIconWrapper>
              }
              disableElevation
              sx={{
                textTransform: "none",
                whiteSpace: "nowrap",
              }}
              onClick={handleLogout}
            >
              {pages?.personal_data?.logout}
            </Button>
          </Box>
        </Box>
        {/*<Box*/}
        {/*  sx={{*/}
        {/*    display: "flex",*/}
        {/*    flexDirection: "column",*/}
        {/*    alignItems: "flex-end",*/}
        {/*    justifyContent: "baseline",*/}
        {/*  }}*/}
        {/*>*/}
        {/*  <Typography variant="caption">Dark theme</Typography>*/}
        {/*  <Switch*/}
        {/*    checked={mode === "dark"}*/}
        {/*    onChange={() => setMode(mode === "dark" ? "light" : "dark")}*/}
        {/*  />*/}
        {/*</Box>*/}
      </Box>

      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, my: 2 }}>
          {pages?.personal_data?.language_title}
        </Typography>
        <LanguageSelect />
      </Box>

      <Box sx={{ mb: 15 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {pages?.personal_data?.personal_info}
        </Typography>
        <Typography variant="caption" sx={{ mt: 2 }}>
          Email
        </Typography>
        <Typography variant="body1">{email}</Typography>
        <PhoneNumber />
        <FirstName />
        <LastName />
        <BirthDate />

        <Box sx={{ my: 2 }}>
          <BaseLink path="/me/personal_data/password">
            {pages?.personal_data?.change_password}
          </BaseLink>
        </Box>

        <Typography variant="h6" sx={{ fontWeight: 700, mt: 2 }}>
          {pages?.personal_data?.physiological_parameters}
        </Typography>

        <Gender />
        <Height />
        <Weight />

        <Box sx={{ mb: 3 }} />

        <SufferedAnInjury />
        <HighCholesterol />
        <Hypertension />
        <Diabets />

        <SecondaryButton fullWidth text={pages?.personal_data?.btn} onClick={handleSubmit} />
      </Box>

      <Navigation />
    </Layout>
  )
}

export default Personal_data
